import React, { useEffect, useState } from 'react';

const NotificationPopup = ({ message, type, onClose, show, redirectUrl, showLoader = false, lenderName = null, openInNewTab = false }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [showRedirectLoader, setShowRedirectLoader] = useState(false);
  const [countdown, setCountdown] = useState(3);

  useEffect(() => {
    if (show) {
      setIsVisible(true);
      
      if (redirectUrl && showLoader) {
        // Start countdown immediately
        setShowRedirectLoader(true);
        setCountdown(3);
        
        // Debug logging
        console.log('=== NotificationPopup Debug ===');
        console.log('redirectUrl:', redirectUrl);
        console.log('lenderName prop:', lenderName);
        console.log('showLoader:', showLoader);
        console.log('============================');
      } else {
        // Auto close after 5 seconds for regular notifications
        const timer = setTimeout(() => {
          setIsVisible(false);
          setTimeout(() => {
            onClose();
          }, 400); // Wait for fade out animation
        }, 5000);

        return () => clearTimeout(timer);
      }
    }
  }, [show, onClose, redirectUrl, showLoader]);

  // Countdown effect
  useEffect(() => {
    if (showRedirectLoader && countdown > 0) {
      const countdownTimer = setTimeout(() => {
        setCountdown(countdown - 1);
      }, 1000);
      
      return () => clearTimeout(countdownTimer);
    } else if (showRedirectLoader && countdown === 0) {
      if (openInNewTab) {
        // For all non-Cashe lenders: open in new tab
        console.log('Opening lender link in new tab:', redirectUrl);
        window.open(redirectUrl, '_blank');
        
        // Auto close notification after 5 seconds and redirect to homepage
        setTimeout(() => {
          setIsVisible(false);
          setTimeout(() => {
            onClose();
            // Redirect to homepage after closing notification
            window.location.href = '/';
          }, 400); // Wait for fade out animation
        }, 5000);
        
        return; // Exit early
      } else if (lenderName === 'cashe') {
        // For CASHe, redirect to application journey in same tab
        console.log('Redirecting CASHe to application journey');
        
        // Auto close notification after 5 seconds
        setTimeout(() => {
          setIsVisible(false);
          setTimeout(() => {
            onClose();
          }, 400); // Wait for fade out animation
        }, 5000);
        
        // Redirect to application journey immediately
        window.location.href = redirectUrl;
        return; // Exit early
      } else if (redirectUrl && typeof redirectUrl === 'string') {
        // Fallback to redirectUrl
        if (redirectUrl.startsWith('http://') || redirectUrl.startsWith('https://')) {
          // Store information that user is going to lender page
          const redirectInfo = {
            goingToLender: true,
            timestamp: Date.now()
          };
          localStorage.setItem('snapfunds_previous_page', JSON.stringify(redirectInfo));
          
          // Redirect to external URL in same tab
          window.location.href = redirectUrl;
        } else {
          // Internal URL redirection
          console.log('Internal redirect URL:', redirectUrl);
          window.location.href = redirectUrl;
        }
      }
    }
  }, [showRedirectLoader, countdown, redirectUrl, lenderName, openInNewTab]);

  const handleClose = () => {
    if (!redirectUrl) {
      setIsVisible(false);
      setTimeout(() => {
        onClose();
      }, 400); // Wait for fade out animation
    }
  };

  if (!show) return null;

  return (
    <div className={`notification-overlay ${isVisible ? 'show' : ''}`}>
      <div className={`notification-popup ${type} ${isVisible ? 'show' : ''}`}>
        {!redirectUrl && (
          <button className="notification-close-btn" onClick={handleClose}>✕</button>
        )}
        <div className="notification-content">
          <div className="notification-icon">
            {type === 'success' ? '✓' : type === 'info' ? '🙂' : '✕'}
          </div>
          <div className="notification-message">
            {message}
          </div>
          {showRedirectLoader && redirectUrl && (
            <div className="notification-loader">
              <div className="countdown-container">
                <div className="countdown-number">{countdown}</div>
              </div>
              <div className="loader-text">
                {lenderName === 'cashe' 
                  ? 'Taking you to application journey …' 
                  : "Taking you to Lender's website …"}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default NotificationPopup;
